import { toLowerCase } from "@/helpers/string.helpers"

const kodemInternalDomain = "kodemsecurity.com"

export const isKodemUser = (email: string) =>
  toLowerCase(email).endsWith(`@${kodemInternalDomain}`)

export const isExternalUser = (email: string) => !isKodemUser(email)

// An SCM email may differ only in case from the same person's Kodem email.
export const isSameEmail = (email: string, other: string) =>
  toLowerCase(email) === toLowerCase(other)
